export const BRAND_CONFIG = {
  name: 'Vediluxe',
  slogan: 'Elegance, Every Day.',
  domains: ['vediluxe.com', 'vedi.luxe']
} as const;

export const PRIMARY_BRAND_DOMAIN = BRAND_CONFIG.domains[0];
